<template>
  <div>
    <div class="hero-slot">
      <picture v-if="backgroundImage && mobileBackgroundImage">
        <source media="(max-width: 1199px)" :srcset="imagePath( mobileBackgroundImage )">
        <img :src="imagePath( backgroundImage )" class="hero-BG" alt="background image" loading="eager">
      </picture>
      <img v-else-if="backgroundImage" :src="imagePath( backgroundImage )" class="hero-BG" alt="background image" loading="eager">

      <div class="container">
        <progress-in-process v-if="!isNaN( currentStep )" :current-step="currentStep" />
        <slot />
      </div>
    </div>
    <advertisers class="hide-in-mobile" />
    <hr class="hide-in-mobile">
    <report class="hide-in-mobile" />
    <hr class="hide-in-mobile">
    <review class="hide-in-mobile" />
    <hr class="hide-in-mobile">
    <privacy class="hide-in-mobile" />
    <hr class="hide-in-mobile">
    <about class="hide-in-mobile" />
  </div>
</template>

<script>
import ProgressInProcess from "@/components/global/progress/InProcess";
import Advertisers from "@/components/landing/Advertisers";
import Report from "@/components/landing/Report";
import Review from "@/components/landing/Review";
import Privacy from "@/components/landing/Privacy";
import About from "@/components/landing/About";
import { imagePath } from "@/utils";

export default {
  name: "StepDisplay",
  props: {
    currentStep: {
      type: [Number, String],
      default: 0
    },
    backgroundImage: {
      type: [String, Boolean],
      default: false
    },
    mobileBackgroundImage: {
      type: [String, Boolean],
      default: false
    },
  },
  components: {
    ProgressInProcess,
    Advertisers,
    Report,
    Privacy,
    About,
    Review,
  },
  setup() {
    return { imagePath };
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/responsive";
.container {
  position: relative;
  z-index: 1;
  padding-top: 52px;
  padding-bottom: 80px;

  @include mobile {

  }
}
.hero-slot {
  background: transparent linear-gradient(180deg, #FDFBFA 0%, #FAF4F2 100%) 0% 0% no-repeat padding-box;
  min-height: 400px;
  overflow: hidden;
  position: relative;

  @include mobile {
    min-height: 100vh;
  }
  .hero-BG {
    position: absolute;
    z-index: 0;
    width: 100%;
  }
}
hr {
  padding: 0;
  margin: 0 auto;
  max-width: 1300px;
}
</style>